export default "__VITE_ASSET__DdOujo99__"